<app-header />

<div [class]="themeClass()" class="main-container">
  <app-side-menu />
  <div class="container">
    <div class="router-content">
      <router-outlet />
      <app-modal />
    </div>
    <app-footer />
  </div>
</div>

@if (isLoading()) {
  <div class="app-loading-overlay" aria-live="polite" aria-busy="true">
    <div class="app-loading-overlay__surface">
      <tds-spinner size="lg"></tds-spinner>
    </div>
  </div>
}
